import { Button, Modal, Select } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { serverUrl } from "../../../../nestserver";
import DatePicker from "../../../../components/inputs/MomentDatePicker";
import AttendanceTable from "./AttendanceTable";
import AttendanceViewHistory from "./AttendanceViewHistory";

const AttendanceHome = () => {
  const { Option } = Select;
  const [ViewHistoryPopup, setViewHistoryPopup] = useState(false);
  const [classId, setClassId] = useState();
  const handleSelectChange = (id) => {
    setClassId(id);
  };

  // fetch classes
  async function fetchClasses() {
    // debugger;
    const res = await axios({
      method: "get",
      url: serverUrl + "/teachers/classes",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const classes = useQuery("classes", fetchClasses);

  const [selectedDate, setSelectedDate] = useState(moment());
  const selectedDateStr = selectedDate.format("YYYY-MM-DD");

  //fetch student attendance (Montessori Logic)
  const fetchStudentData = async () => {
    const res = await axios.get(
      `${serverUrl}/montessori/attendance/class/${classId}?date=${selectedDateStr}`,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      },
    );

    return res.data;
  };
  const attendanceData = useQuery(
    ["montessori-attendance", classId, selectedDateStr],
    fetchStudentData,
    {
      enabled: !!classId,
    },
  );
  const classDetails = attendanceData?.data?.result?.classDetails;

  return (
    <div className="attendance">
      <div className="pt-8">
        <div className="bg-white p-10 rounded-2xl">
          <div className="flex justify-between items-center pb-8">
            <div className="text-2xl text-orange-500 font-semibold">
              Attendance
            </div>
            <Button size="large" onClick={() => setViewHistoryPopup(true)}>
              View History
            </Button>
          </div>
          <div className="flex gap-10px pb-4">
            <h6 className=" font-semibold text-base">Class: &nbsp;</h6>
            <Select
              showSearch
              showArrow
              allowClear
              placeholder="Select Class"
              className="w-1/2 bg-gray-300"
              style={{
                border: "6px",
                backgroundColor: "#EBEBEB",
                width: "33%",
              }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(value) => handleSelectChange(value)}
            >
              <>
                {classes?.isSuccess &&
                  classes?.data?.map((data) => {
                    return (
                      <Option key={data._id} value={data._id}>
                        {data.name}
                      </Option>
                    );
                  })}
              </>
            </Select>
          </div>
          <div className="flex justify-between items-center pb-4">
            <h6 className="text-base font-semibold flex items-center">
              Date: &nbsp;
              <DatePicker
                value={selectedDate}
                format="DD MMM YYYY"
                allowClear={false}
                disabledDate={(d) => !d || d.isAfter(moment().endOf("day"))}
                onChange={(date) => date && setSelectedDate(date)}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </h6>
          </div>
          <div className="flex justify-between items-center">
            <h6 className="text-base font-semibold">
              Last Marked: &nbsp;
              <span className="text-base font-medium">
                {(classDetails?.check_out_time ||
                  classDetails?.check_in_time) &&
                  moment(
                    classDetails?.check_out_time || classDetails?.check_in_time,
                  ).format("DD MMM YYYY hh:mm")}
              </span>
            </h6>
          </div>
          <div>
            <AttendanceTable
              classId={classId}
              attendanceData={attendanceData}
              selectedDate={selectedDateStr}
            />
          </div>

          {/* View History Modal */}
          <Modal
            width={900}
            visible={ViewHistoryPopup}
            onOk={() => setViewHistoryPopup(false)}
            onCancel={() => {
              setViewHistoryPopup(false);
            }}
            footer={null}
          >
            <AttendanceViewHistory classId={classId} />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default AttendanceHome;
